import assertNever from "assert-never";

/**
 * The status of a Caregiver within a specific Agency
 */
export const CaregiverStatus = {
  /**
   * The Caregiver will receive available visits from the agency, but is
   * unable to request them because she is still waiting to be processed
   * into the agency.
   */
  PENDING: "PENDING" as const,

  /**
   * The Caregiver will receive available visits from the agency and is able
   * to request them
   */
  ACTIVE: "ACTIVE" as const,

  /**
   * This is just like active...
   * The Caregiver will receive available visits from the agency and is able
   * to request them
   */
  ON_LEAVE: "ON_LEAVE" as const,

  /**
   * The caregiver will receive available visits from the agency, but is
   * unable to request them because her file is missing documents or other
   * requirements.
   */
  ON_HOLD: "ON_HOLD" as const,

  /**
   * The caregiver will not receive any visits from the agency, because she
   * has been suspended.
   */
  SUSPENDED: "SUSPENDED" as const,

  /**
   * The caregiver will not receive any visits from the agency because she
   * has been terminated.
   */
  TERMINATED: "TERMINATED" as const,

  /**
   * The caregiver requested to join the agency
   */
  JOIN_REQUEST: "JOIN_REQUEST" as const,

  /**
   * The caregiver will not receive any visits from the agency, because she
   * quit the agency.
   */
  QUIT: "QUIT" as const,

  /**
   * The caregiver will not receive any visits or onboarding data from the agency, because she
   * is rejected by the agency.
   */
  REJECTED: "REJECTED" as const,
};

export type CaregiverStatus =
  | "PENDING"
  | "ACTIVE"
  | "ON_HOLD"
  | "SUSPENDED"
  | "TERMINATED"
  | "ON_LEAVE"
  | "JOIN_REQUEST"
  | "QUIT"
  | "REJECTED";

export function isStatusEligibleToRequestVisit(status: CaregiverStatus): boolean {
  switch (status) {
    case "ON_LEAVE":
    case "ACTIVE":
      return true;
    case "PENDING":
    case "ON_HOLD":
    case "SUSPENDED":
    case "TERMINATED":
    case "JOIN_REQUEST":
    case "QUIT":
    case "REJECTED":
      return false;
    default:
      return assertNever(status);
  }
}
